export const getUserData = () => {
    const apiEndpointPrefix = process.env.AGROFYAPI_ENDPOINT_SERVICES_PREFIX || window.env.AGROFYAPI_ENDPOINT_SERVICES_PREFIX;
    return fetch(`${apiEndpointPrefix}/user`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        return data;
      });
  };